import styled from 'styled-components'

export const Container = styled.div`
    .MJXp-math,
    .MJXc-TeX-math-I,
    .mjx-chtml,
    .MJXp-italic {
        font-family: unset;
        font-style: unset;
    }
`
